export const BRAND = {
  DEFAULT_COLORS: ['#F25924', '', ''],
};
